import React from 'react';
import type { PageDetailOut } from '../types/catalog';
import { ReadListenV1 } from './templates/ReadListenV1';
import { McqChoiceV1 } from './templates/McqChoiceV1';
import { McqImageV1 } from './templates/McqImageV1';
import { FillBlanksV1 } from './templates/FillBlanksV1';
import { SpeakRepeatV1 } from './templates/SpeakRepeatV1';
import { PracticeTracingV1 } from './PracticeTracingV1';
import { PracticeSpeakingValidateV1 } from './PracticeSpeakingValidateV1';
import { PhonicsReviewGridV2 } from './templates/PhonicsReviewGridV2';
import { PhonicsConceptV2 } from './templates/PhonicsConceptV2';
import { PhonicsSyllableFormV2 } from './templates/PhonicsSyllableFormV2';
import { VocabPictureCardsV2 } from './templates/VocabPictureCardsV2';
import { MediaVideoWithTextV1 } from './templates/MediaVideoWithTextV1';
import { StoryVideoWithPagesV1 } from './templates/StoryVideoWithPagesV1';
import { PhonicsCardsV1 } from './templates/PhonicsCardsV1';
import { VocabPictureLabelsV1 } from './templates/VocabPictureLabelsV1';

export const TEMPLATE_IDS = {
  READ_LISTEN_V1: 'read.listen.v1',
  MCQ_CHOICE_V1: 'mcq.choice.v1',
  MCQ_IMAGE_V1: 'mcq.image.v1',
  FILL_BLANKS_V1: 'fill.blanks.v1',
  SPEAK_REPEAT_V1: 'speak.repeat.v1',
  PHONICS_REVIEW_GRID_V2: 'phonics.review_grid.v2',
  PHONICS_CONCEPT_V2: 'phonics.concept.v2',
  PHONICS_SYLLABLE_FORM_V2: 'phonics.syllable_form.v2',
  PHONICS_CARDS_V1: 'phonics.cards.v1',
  VOCAB_PICTURE_CARDS_V2: 'vocab.picture_cards.v2',
  VOCAB_PICTURE_LABELS_V1: 'vocab.picture_labels.v1',
  MEDIA_VIDEO_WITH_TEXT_V1: 'media.video_with_text.v1',
  STORY_VIDEO_WITH_PAGES_V1: 'story.video_with_pages.v1',
  PRACTICE_TRACING_V1: 'practice.tracing.v1',
  PRACTICE_SPEAKING_VALIDATE_V1: 'practice.speaking.validate.v1',
} as const;

export type TemplateId = (typeof TEMPLATE_IDS)[keyof typeof TEMPLATE_IDS];

export interface TemplateComponentProps {
  page: PageDetailOut;
  onComplete?: () => void;
}

export type TemplateComponent = React.FC<TemplateComponentProps>;

const registry: Record<string, TemplateComponent> = {
  [TEMPLATE_IDS.READ_LISTEN_V1]: ReadListenV1,
  [TEMPLATE_IDS.MCQ_CHOICE_V1]: McqChoiceV1,
  [TEMPLATE_IDS.MCQ_IMAGE_V1]: McqImageV1,
  [TEMPLATE_IDS.FILL_BLANKS_V1]: FillBlanksV1,
  [TEMPLATE_IDS.SPEAK_REPEAT_V1]: SpeakRepeatV1,
  [TEMPLATE_IDS.PHONICS_REVIEW_GRID_V2]: PhonicsReviewGridV2,
  [TEMPLATE_IDS.PHONICS_CONCEPT_V2]: PhonicsConceptV2,
  [TEMPLATE_IDS.PHONICS_SYLLABLE_FORM_V2]: PhonicsSyllableFormV2,
  [TEMPLATE_IDS.PHONICS_CARDS_V1]: PhonicsCardsV1,
  [TEMPLATE_IDS.VOCAB_PICTURE_CARDS_V2]: VocabPictureCardsV2,
  [TEMPLATE_IDS.VOCAB_PICTURE_LABELS_V1]: VocabPictureLabelsV1,
  [TEMPLATE_IDS.MEDIA_VIDEO_WITH_TEXT_V1]: MediaVideoWithTextV1,
  [TEMPLATE_IDS.STORY_VIDEO_WITH_PAGES_V1]: StoryVideoWithPagesV1,
  [TEMPLATE_IDS.PRACTICE_TRACING_V1]: PracticeTracingV1,
  [TEMPLATE_IDS.PRACTICE_SPEAKING_VALIDATE_V1]: PracticeSpeakingValidateV1,
};

export function getTemplateComponent(templateId: string | undefined): TemplateComponent | null {
  if (!templateId) return null;
  return registry[templateId] ?? null;
}
